import { StyleSheet, Text, View, TouchableOpacity } from 'react-native';
import React from 'react';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import { localTime, isWeb } from '@helpers';

import { font } from '@styles/fonts';
import Svg from '@styles/icons/svg';
import { useManageUtilizationPopup } from '@components/machines/components/Utilization/components/chart/hooks/useManageUtilizationPopup';
import { SCREEN_BORDER_RADIUS, TEST_IDS } from '@v2/pages/common/constants/base.constants';

export default ({ C, selectedItem, selectedIndex, toGo, isDay, id, barBlockWidth }) => {
  const { chartHeight, lineLeft, teepInt, teepDec, oeeInt, oeeDec, effectiveness, linkConfig } = useManageUtilizationPopup({
    selectedItem,
    selectedIndex,
    toGo,
    barBlockWidth,
  });

  return (
    <View testID={TEST_IDS.utilizationPopup.container} style={{ width: '100%', paddingHorizontal: scale(15), marginBottom: scale(6) }}>
      {/* Drill-down (arrow */}
      {id && !isDay && (
        <TouchableOpacity
          testID={TEST_IDS.utilizationPopup.toGoButton}
          activeOpacity={1}
          onPress={(e) => {
            e.preventDefault();
            toGo(selectedItem);
          }}
          style={{ position: 'absolute', zIndex: 10000, top: scale(4), right: scale(4), borderRadius: scale(SCREEN_BORDER_RADIUS), backgroundColor: C('Fill/Light/Secondary') }}
          href={
            isDay
              ? ''
              : `/machines?id=${id}&section=${linkConfig?.section}&date=${localTime(linkConfig?.date).format('YYYY-MM-DD HH:mm')}`
          }
        >
          <View>
            <Svg icon="togo" width={scale(20)} height={scale(20)} color="Label/Light/Tertiary" />
          </View>
        </TouchableOpacity>
      )}

      {/* Background box */}
      <View
        style={{
          position: 'absolute',
          top: scale(0),
          left: scale(0),
          right: scale(0),
          bottom: scale(0),
          backgroundColor: C('Fill/Light/Quaternary'),
          borderRadius: scale(SCREEN_BORDER_RADIUS),
          borderWidth: StyleSheet.hairlineWidth,
          borderColor: C('Fill/Light/Quaternary'),
        }}
      />

      {/* 2-Column layout */}
      <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
        {/* Left Column - OEE */}
        <View testID={TEST_IDS.utilizationPopup.oeeColumn} style={{ flex: 1 }}>
          <View>
            <Text style={[font['Button 2'], { color: C('OEE/Light/OEE Chart') }]}>{i18n.t('OEE')}</Text>
          </View>
          <View style={{ flexDirection: 'row', alignItems: 'baseline' }}>
            <Text style={[font['Large Title'], { color: C('OEE/Light/OEE Chart') }]}>{oeeInt}</Text>
            {oeeDec && (
              <Text style={[font['Large Title'], { color: C('OEE/Light/OEE Chart') }]}>
                ,{oeeDec}
              </Text>
            )}
            <Text style={[font['Button 1'], { color: C('OEE/Light/OEE Chart'), marginTop: scale(isWeb ? 16 : 11) }]}>
              %
            </Text>
            {effectiveness && (
              <Text testID={TEST_IDS.utilizationPopup.effectiveness} style={[font['Button 2'], { color: C(effectiveness.color), marginLeft: scale(6) }]}>
                {effectiveness.label}
              </Text>
            )}
          </View>
        </View>
        {/* Right Column - Net Utilization */}
        <View testID={TEST_IDS.utilizationPopup.teepColumn} style={{ flex: 1 }}>
          <View>
            <Text style={[font['Button 2'], { color: C('OEE/Light/TEEP') }]}>{i18n.t('Net Utilization')}</Text>
          </View>
          <View style={{ flexDirection: 'row' }}>
            <Text style={[font['Large Title'], { color: C('OEE/Light/TEEP') }]}>{teepInt}</Text>
            {teepDec && (
              <Text style={[font['Large Title'], { color: C('OEE/Light/TEEP') }]}>
                ,{teepDec}
              </Text>
            )}
            <Text style={[font['Button 1'], { color: C('OEE/Light/TEEP'), marginTop: scale(isWeb ? 16 : 11) }]}>%</Text>
          </View>
        </View>
      </View>

      {/* Date row */}
      <View>
        <Text testID={TEST_IDS.utilizationPopup.date} style={[font['Subhead 1'], { color: C('Label/Light/Quaternary'), fontVariant: ['tabular-nums'] }]}>
          {selectedItem.date}
        </Text>
      </View>

      {/* Vertical line extending down into chart */}
      <View
        testID={TEST_IDS.utilizationPopup.verticalLine}
        style={{
          position: 'absolute',
          width: 1,
          backgroundColor: C('Label/Light/Tertiary'),
          height: chartHeight - (selectedItem.height / 100) * chartHeight + scale(4),
          top: scale(80),
          left: lineLeft,
          zIndex: 1000,
        }}
      />
    </View>
  );
};
